import { render } from "./FormPicker.vue?vue&type=template&id=8b289cbe"
import script from "./FormPicker.vue?vue&type=script&lang=js"
export * from "./FormPicker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__